var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"suffix":`${_vm.getSuffix}`},on:{"keypress":(e) => _vm.manageLimit(e),"paste":(e) => _vm.onPaste(e)},model:{value:(_vm.textInputValue),callback:function ($$v) {_vm.textInputValue=$$v},expression:"textInputValue"}},'v-text-field',{
    ..._vm.$attrs,
  },false))
}
var staticRenderFns = []

export { render, staticRenderFns }